import { render, staticRenderFns } from "./SampleLayout.vue?vue&type=template&id=a6193b8a&"
import script from "./SampleLayout.vue?vue&type=script&lang=js&"
export * from "./SampleLayout.vue?vue&type=script&lang=js&"
import style0 from "./SampleLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports